'use client';

import { mittInstance } from '@/constants/mitt-instance';
import Autoplay from 'embla-carousel-autoplay';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel';

const AnnouncementsList = props => {
  const { data } = props;

  const moreThanOne = data.length > 1;
  const [carouselApi, setCarouselApi] = useState(null);

  useEffect(() => {
    if (!carouselApi) {
      return;
    }

    const pointerDownHandler = () => {
      if (moreThanOne) {
        carouselApi?.plugins()?.autoplay?.stop();
      }
    };

    const pointerUpHandler = () => {
      if (moreThanOne) {
        carouselApi?.plugins()?.autoplay?.play();
      }
    };

    carouselApi.on('pointerDown', pointerDownHandler);
    carouselApi.on('pointerUp', pointerUpHandler);

    return () => {
      carouselApi.off('pointerDown', pointerDownHandler);
      carouselApi.off('pointerUp', pointerUpHandler);
    };
  }, [carouselApi, moreThanOne]);

  return data.length > 0 ? (
    <div className='bg-BE9983   text-sm text-white'>
      <div
        className='mx-auto  flex max-w-[700px] items-center gap-x-1 px-[15px] lg_px-0'
        onMouseEnter={() => {
          if (moreThanOne) {
            carouselApi?.plugins()?.autoplay?.stop();
          }
        }}
        onMouseLeave={() => {
          if (moreThanOne) {
            carouselApi?.plugins()?.autoplay?.play();
          }
        }}
      >
        {moreThanOne ? (
          <button
            className='flex-none'
            type='button'
            onClick={() => {
              carouselApi?.scrollPrev();
            }}
            aria-label='prev-announcement'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='8'
              height='14'
              fill='none'
              viewBox='0 0 8 14'
            >
              <path
                stroke='#fff'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M7 .5L1 7l6 6.5'
              />
              <path
                stroke='#fff'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeOpacity='0.2'
                d='M7 .5L1 7l6 6.5'
              />
            </svg>
          </button>
        ) : null}
        <div className='flex-1 overflow-hidden'>
          <Carousel
            plugins={[
              Autoplay({
                playOnInit: true,
                delay: 3000,
              }),
            ]}
            opts={{
              loop: true,
            }}
            setApi={setCarouselApi}
          >
            <CarouselContent>
              {data.map(item => {
                return (
                  <CarouselItem key={item.id}>
                    <div
                      className='flex h-[38px] items-center  justify-center text-center leading-none lg_h-[30px]'
                      onClick={() => {
                        if (item.title === 'Easter Raffle') {
                          mittInstance.emit('OPEN_EASTER_RAFFLE');
                        }
                      }}
                    >
                      {parse(item.content)}
                    </div>
                  </CarouselItem>
                );
              })}
            </CarouselContent>
          </Carousel>
        </div>
        {moreThanOne ? (
          <button
            className='flex-none'
            type='button'
            onClick={() => {
              carouselApi?.scrollNext();
            }}
            aria-label='next-announcement'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='7'
              height='13'
              fill='none'
              viewBox='0 0 7 13'
            >
              <path
                fill='#fff'
                fillRule='evenodd'
                d='M.174 12.894a.36.36 0 0 1 0-.515L6.114 6.5.173.62a.36.36 0 0 1 0-.513.37.37 0 0 1 .52 0l6.198 6.136a.36.36 0 0 1 0 .514L.694 12.894a.37.37 0 0 1-.52 0'
                clipRule='evenodd'
              />
            </svg>
          </button>
        ) : null}
      </div>
    </div>
  ) : null;
};

export default AnnouncementsList;
